var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular.module('QMC.Nachrichten', ['QMC.Klient']).config(routes).filter('renderHTMLCorrectly', $sce => stringToParse => {
        return $sce.trustAsHtml(stringToParse);
    });
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('mailbox', {
            url: '/mailbox?:folderId:messageId',
            templateUrl: qmcBase + '/Nachrichten',
            controller: 'NachrichtenController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Mailbox');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var InternalMessage;
    (function (InternalMessage) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        InternalMessage.HttpProvider = HttpProvider;
    })(InternalMessage = QMC.InternalMessage || (QMC.InternalMessage = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Nachrichten')
        .config(['$httpProvider', QMC.InternalMessage.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var InternalMessage;
    (function (InternalMessage) {
        let NachrichtenService = class NachrichtenService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/InternalMessage';
            }
            getMessageList(dateFrom, dateTo, folderId, page, pageSize) {
                return super.getPagination(this.modulePath, { folderId: folderId, page: page, pageSize: pageSize, dateFrom: dateFrom, dateTo: dateTo }, (data) => {
                    return data;
                });
            }
            getMessage(id) {
                return super.getItem(this.modulePath + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getFolderList() {
                return super.get(this.modulePath + '/Folder', {}, (data) => {
                    return data;
                });
            }
            getUnreadCount() {
                return super.get(this.modulePath + '/UnreadCount', {}, (data) => {
                    return data;
                });
            }
            /**
             * Downloads one or more attachments of a message. If attachmentId is not set, it downloads all attachments of the message as a zip file.
             * @param messageId The object id of the message.
             * @param attachmentId The id of the attachment. If not set, all attachments will be downloaded as a zip file.
             */
            downloadAttachment(messageId, attachmentId) {
                return super.getItem(this.modulePath + '/' + messageId + '/Attachment', { attachmentId: attachmentId }).then((data) => {
                    return data.base64;
                });
            }
            getAvailableRecipients() {
                return super.get(this.modulePath + '/AvailableRecipients', {}, (data) => {
                    return data;
                });
            }
            getRecipientList(id) {
                return super.get(this.modulePath + '/' + id + '/Recipient', {}, (data) => {
                    return data;
                });
            }
            postMessage(data) {
                return super.post(this.modulePath, data).then((e) => {
                    return e;
                });
            }
            deleteMessage(id, deleteFromSend = false) {
                return super.delete(this.modulePath + '/' + id + '?deleteFromSendFolder=' + deleteFromSend).then((data) => {
                    return data;
                });
            }
            markMessageAsRead(request) {
                return super.put(this.modulePath + '/MarkAsRead', request).then((data) => {
                    return data;
                });
            }
            moveMessageToFolder(request) {
                return super.put(this.modulePath + '/MoveToFolder', request).then((data) => {
                    return data;
                });
            }
            moveMessageToRecycleBin(request) {
                super.put(this.modulePath + '/MoveToRecycleBin', request);
            }
            postFolder(data) {
                return super.post(this.modulePath + '/Folder', data).then((e) => {
                    return e;
                });
            }
            putFolder(id, data) {
                return super.put(this.modulePath + '/Folder/' + id, data).then((e) => {
                    return e;
                });
            }
            deleteFolder(id) {
                return super.delete(this.modulePath + '/Folder/' + id).then((e) => {
                    return e;
                });
            }
            //Draft
            getDrafts() {
                return super.get(this.modulePath + '/Draft', {}, (data) => {
                    data.forEach(x => {
                        x.content = JSON.parse(x.content);
                        x.content.recipientIds = x.content.recipientIds ? x.content.recipientIds : [];
                        x.lastUpdate = x.lastUpdate ? moment(x.lastUpdate).toDate() : new Date();
                    });
                    return data;
                });
            }
            postDraft(dataOriginal) {
                const data = angular.copy(dataOriginal);
                data.content = JSON.stringify(data.content);
                return super.post(this.modulePath + '/Draft', data).then((e) => {
                    return e.createdObjectId;
                });
            }
            putDraft(id, dataOriginal) {
                const data = angular.copy(dataOriginal);
                data.content = JSON.stringify(data.content);
                return super.put(this.modulePath + '/Draft/' + id, data).then((e) => {
                    return e;
                });
            }
            deleteDraft(id) {
                return super.delete(this.modulePath + '/Draft/' + id).then((e) => {
                    return e;
                });
            }
        };
        NachrichtenService = __decorate([
            QMC.Service('QMC.Nachrichten', 'NachrichtenService'),
            QMC.Inject('$http', '$q')
        ], NachrichtenService);
        InternalMessage.NachrichtenService = NachrichtenService;
    })(InternalMessage = QMC.InternalMessage || (QMC.InternalMessage = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var InternalMessage;
    (function (InternalMessage) {
        let NachrichtenController = class NachrichtenController {
            constructor($location, nachrichtenService, $qui, $stateParams, $state, $scope, lng, userService) {
                this.$location = $location;
                this.nachrichtenService = nachrichtenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.$scope = $scope;
                this.lng = lng;
                this.userService = userService;
                // tslint:disable-next-line:no-unused-variable
                this.ui = new QMC.InternalMessage.UserInterface();
                this.folderFormCreateState = "new";
                this.folderFormUpdateState = "edit";
                this.selectedMessageIds = [];
                this.selectedFileNames = [];
                this.uploads = [];
                this.inboxFolderId = QMC.Common.Constants.MESSAGE_INBOX_FOLDER_ID;
                this.sentFolderId = QMC.Common.Constants.MESSAGE_SENT_FOLDER_ID;
                this.recycleBinFolderId = QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID;
                this.forwardRecipients = [];
                this.useTrash = true;
                this.daysToPast = 0;
                this.summernoteOptions = {
                    height: 350,
                    focus: true,
                    airMode: false,
                    lang: 'de-DE',
                    toolbar: [
                        ['font', ['bold', 'italic', 'underline', 'clear']],
                        ['alignment', ['ul', 'ol']]
                    ],
                    callbacks: { onChange: (...args) => { this.onSummernoteChange(args[0], $(args[1][0])); } }
                };
                this.recs = [];
                this.readMode = true;
                this.drafts = [];
                this.draftFolderId = '00000000-0000-0000-0000-000000000005';
                /**
                 * setFilterView
                 * @description Set FilterList spaceing.
                 */
                this.selectedFilter = null;
                this.checkToggle = true;
                this.selectedRecs = [];
                this.isDraftPosting = false;
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    setTimeout(() => {
                        if (QMC.Common.Constants.IS_MOBILE) {
                            $("#page-wrapper").addClass("notification");
                            $(window).unbind("scroll");
                            $("body").css("overflow-y", "hidden");
                            $scope.$on("$destroy", function () {
                                $("#page-wrapper").removeClass("notification");
                            });
                        }
                    }, 500);
                });
                this.isInit = true;
                this.reply = false;
                this.replyToAll = false;
                this.folderLoading = true;
                if (document.getElementById("permissions").getAttribute("message").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module message");
                    this.forbidden = true;
                    return;
                }
                this.init();
                this.resetMessageList();
                this.resetNewForm();
                this.getFolders();
                this.userService.getUserSettings(["INTERNENACHRICHTEN.USETRASH", "INTERNENACHRICHTEN.ANZEIGEANZAHLTAGE"], false).then((data) => {
                    this.useTrash = data[0].value.toLowerCase().trim() === "true" || data[0].value.toLowerCase().trim() === "";
                    this.daysToPast = parseInt(data[1].value);
                    if (this.daysToPast > 0) {
                        const temp = new Date();
                        temp.setDate(temp.getDate() - this.daysToPast);
                        this.filter.filterDateFrom = temp;
                        this.filter.dateFrom.setDate = temp;
                    }
                    this.setFilter();
                });
                this.promptOptionsFolderDelete = {
                    title: this.lng.translate(21004023, "Ordner"),
                    icon: "qm-icon-folder",
                    yesNo: true,
                    id: "prompt-folder-delete",
                    text: this.lng.translate(21004043, 'Wollen Sie den ausgewählten Ordner mit allen Unterordnern wirklich löschen?')
                };
                setTimeout(() => {
                    $('#' + this.selectedFolderId).addClass('active-folder');
                }, 500);
                this.getAvailableRecipients();
            }
            onSummernoteChange(content, element) {
                // check for parent
                if (element.closest('#summernoteNewMessage').length > 0) { //newMode
                    this.newMessageDraft(content);
                }
                if (element.closest('#summernoteAnswerMessage').length > 0) { //answerMode
                    this.replyMessageDraft(content);
                }
                if (element.closest('#summernoteForwardMessage').length > 0) { //forwardMode
                    this.forwardMessageDraft(content);
                }
            }
            /**
             *  init
             *  @description Init the filter
             */
            init() {
                $('#summernoteNewMessage .summernote').summernote(this.summernoteOptions);
                $('#summernoteAnswerMessage .summernote').summernote(this.summernoteOptions);
                $('#summernoteForwardMessage .summernote').summernote(this.summernoteOptions);
                this.filter = {
                    dateFrom: moment().subtract(3, 'months').toDate(),
                    dateTo: new Date(),
                    filterDateFrom: moment().subtract(3, 'months').toDate(),
                    filterDateTo: new Date()
                };
                this.folderFormCreate = {
                    name: '',
                    parentFolderId: null,
                    order: 0,
                };
                this.folderFormUpdate = {
                    name: '',
                    parentFolderId: null,
                    order: 0,
                };
                //calculate postbox height
                if (!QMC.Common.Constants.IS_MOBILE) {
                    $(window).resize(() => { $('#folderList').height($('#folderPane').height() - 190); });
                    $('#folderList').height($('#folderPane').height() - 190);
                }
                this.$scope.$watch('vm.newForm', (newVal, oldVal) => {
                    if (newVal !== oldVal && newVal)
                        this.newMessageDraft($('#summernoteNewMessage').find('.note-editable').html());
                }, true);
                this.$scope.$watch('vm.forwardRecipients', (newVal, oldVal) => {
                    if (newVal !== oldVal && newVal && newVal.length !== oldVal.length)
                        this.forwardMessageDraft($('#summernoteForwardMessage').find('.note-editable').html());
                });
            }
            setFilterView(filter, px) {
                this.transferFolder = null;
                $("[data-filter]").fadeOut("fast");
                if (filter === this.selectedFilter || filter === 'hide') {
                    this.filterHeight = 0;
                    this.selectedFilter = null;
                    $(".scroll-container").css("top", 56);
                    $("[data-filter]").fadeOut("fast");
                }
                else {
                    this.selectedFilter = filter;
                    if (this.filterHeight > 0) {
                        $(".scroll-container").css("top", 56);
                        setTimeout(() => {
                            $(".scroll-container").css("top", px);
                            $("[data-filter='" + filter + "']").fadeIn("fast");
                            this.filterHeight = px;
                        }, 500);
                    }
                    else {
                        $("[data-filter='" + filter + "']").fadeIn("fast");
                        $(".scroll-container").css("top", px);
                        this.filterHeight = px;
                    }
                }
            }
            /**
             * setFilter
             * @description Set the current filter values
             */
            setFilter() {
                this.filter = {
                    filterDateFrom: this.filter.filterDateFrom,
                    filterDateTo: this.filter.filterDateTo,
                    dateFrom: this.filter.filterDateFrom,
                    dateTo: this.filter.filterDateTo
                };
                this.getMessagesOfCurrentFolder();
            }
            toggleAllCheckboxes() {
                console.log(this.messageList.items);
                for (const msg in this.messageList.items)
                    this.messageList.items[msg].isSelected = this.checkToggle;
                this.checkToggle = !this.checkToggle;
                this.getSelectedMessages();
            }
            getSelectedMessages() {
                var areMessSelected = false;
                const messageIds = [];
                for (let i = 0; i < this.messageList.items.length; i++) {
                    if (this.messageList.items[i].isSelected) {
                        messageIds.push(this.messageList.items[i].messageObjectId);
                        areMessSelected = true;
                    }
                }
                if (!areMessSelected) {
                    this.setFilterView('hide', 140);
                }
                this.selectedMessageIds = messageIds;
                this.$qui.scopeApply(this.$scope);
            }
            changeFolder(folder) {
                this.setFilterView('hide', 140);
                $('#' + this.selectedFolderId).removeClass('active-folder');
                this.selectedMessageIds = [];
                this.folderLoading = true;
                this.shownMessage = null;
                this.isNewMessage = false;
                this.selectedFolder = folder;
                this.selectedFolderId = folder.id;
                this.selectedFolderName = folder.caption;
                this.getMessagesOfCurrentFolder();
                this.reply = false;
                this.replyToAll = false;
                this.reply = false;
                this.folderFormUpdateState = 'edit';
                this.folderFormUpdate = {
                    name: this.selectedFolder.caption,
                    parentFolderId: this.selectedFolder.parentObjectId,
                    order: this.selectedFolder.order,
                };
                if (this.selectedFolderId !== this.draftFolderId)
                    this.ui.createFolderUpdateForm();
                this.isSendFolder = this.selectedFolderId === QMC.Common.Constants.MESSAGE_SENT_FOLDER_ID;
                $('#' + this.selectedFolderId).addClass('active-folder');
            }
            fileTypeIcon(fileName) {
                const type = fileName.split('.')[fileName.split('.').length - 1];
                let icon = "fa fa-";
                switch (type) {
                    case ('jpg'):
                    case ('gif'):
                    case ('png'):
                        icon += "file-image-o";
                        break;
                    case ('txt'):
                        icon += "file-txt-o";
                        break;
                    case ('xdoc'):
                    case ('doc'):
                        icon += "file-word-o";
                        break;
                    case ('zip'):
                    case ('rar'):
                        icon += "file-zip-o";
                        break;
                    case ('pdf'):
                        icon += "file-pdf-o";
                        break;
                    case ('csv'):
                    case ('xlxs'):
                        icon += "file-excel-o";
                        break;
                    case ('xppt'):
                    case ('ppt'):
                        icon += "file-powerpoint-o";
                        break;
                    default:
                        icon += "file-o";
                }
                return icon;
            }
            recSelect() {
                this.selectedRecs = [];
                this.newForm.recipientIds = [];
                for (const select in this.recs)
                    if (this.recs[select].isSelected) {
                        this.newForm.recipientIds.push(this.recs[select].objectId);
                        this.selectedRecs.push(this.recs[select]);
                    }
                this.$qui.bindEvents();
            }
            showMessage(id) {
                if (this.selectedFolderId === this.draftFolderId) {
                    this.openDraft(id);
                    return;
                }
                $('#summernoteAnswerMessage').find('.note-editable').html('');
                this.loading = true;
                this.reply = false;
                this.forward = false;
                this.nachrichtenService.getMessage(id).then((data) => {
                    this.shownMessage = data;
                    this.markShownMessageAsRead();
                    $('#summernoteAnswerMessage').find('.note-editable').html(this.getAnswerString(data));
                    $('#summernoteForwardMessage').find('.note-editable').html(this.getAnswerString(data));
                    this.loading = false;
                    setTimeout(() => {
                        this.$qui.scheduleInitTooltip();
                    }, 600);
                });
            }
            print() {
                const areas = document.getElementsByName('printableAreas');
                const winPrint = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');
                for (let i = 0; i < areas.length; i++) {
                    winPrint.document.write(areas[i].innerHTML);
                    console.log(this.shownMessage.recipients.length);
                    if (this.shownMessage.recipients.length === 0) {
                        winPrint.document.getElementById('recipients').remove();
                    }
                    ;
                    winPrint.document.getElementById('buttons').remove();
                    if (this.shownMessage.attachments.length === 0) {
                        winPrint.document.getElementById('mailattachments').remove();
                    }
                    if (i % 2 == 1)
                        winPrint.document.write("<br /><br />");
                }
                winPrint.document.close();
                winPrint.focus();
                winPrint.print();
                winPrint.close();
            }
            getAnswerString(data) {
                const date = this.$qui.createDateFromString(data.dateCreated);
                let answer = '<br /> <br /> <small>' + data.sender;
                answer += " " + "schrieb am:" + " ";
                answer += date.toLocaleDateString();
                answer += " " + "um:" + " ";
                answer += date.getHours() + ":" + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
                answer += "</small><p>" + data.messageText + "</p>";
                return answer;
            }
            renderMessageHTML(htmlString) {
                $(".mail-text-area").html(htmlString);
            }
            openNewMessage() {
                this.resetNewForm();
                this.isNewMessage = true;
                $("#newMessageBox").focus();
            }
            cancelNewMessage() {
                this.resetNewForm();
                this.isNewMessage = false;
            }
            resetMessageList() {
                this.messageList = { items: [], paginationInfo: { totalItemsCount: 0, totalPages: 0 } };
            }
            resetNewForm() {
                $('#summernoteNewMessage').find('.note-editable').html('');
                this.newForm = { messageText: '', recipientIds: [], subject: "", attachments: [] };
                this.uploads = [];
                this.selectedFileNames = [];
                this.currentDraftId = undefined;
                this.isDraftPosting = false;
                this.recs.forEach(x => x.isSelected = false);
            }
            updateFlatFolderList() {
                this.flatFolderList = this.getFlatFolderList();
            }
            getFolders() {
                this.folderList = [];
                this.nachrichtenService.getFolderList().then((data) => {
                    this.folderList = data;
                    this.updateFlatFolderList();
                    if (this.$stateParams.folderId === undefined) {
                        this.selectedFolderId = QMC.Common.Constants.MESSAGE_INBOX_FOLDER_ID;
                        this.selectedFolderName = this.lng.translate(21004022, "Posteingang");
                    }
                    else {
                        for (let i = 0; i < this.folderList.length; i++) {
                            if (data[i].id === this.$stateParams.folderId || data[i].id === this.$stateParams.folderId) {
                                this.changeFolder(data[i]);
                                break;
                            }
                        }
                    }
                    this.$qui.functionWaiter("ui.createFolderForm", this);
                    this.$qui.functionWaiter("ui.createFolderUpdateForm", this);
                    this.getDrafts();
                });
            }
            updateFolderList() {
                this.nachrichtenService.getFolderList().then((data) => {
                    this.folderList = data;
                    this.updateFlatFolderList();
                    setTimeout(() => {
                        $('#' + this.selectedFolderId).addClass('active-folder');
                        this.$scope.apply;
                    }, 500);
                });
            }
            getFlatFolderList() {
                const result = [];
                this.folderListGeneratorRecursive(this.folderList, result);
                return result;
            }
            folderListGeneratorRecursive(data, result) {
                if (!data)
                    return;
                for (let i = 0; i < data.length; i++) {
                    result.push(data[i]);
                    if (data[i].children.length > 0)
                        this.folderListGeneratorRecursive(data[i].children, result);
                }
            }
            getShownMessageById(id) {
                this.reply = false;
                this.forward = false;
                this.nachrichtenService.getMessage(id).then(data => {
                    this.shownMessage = data;
                    setTimeout(() => {
                        this.$qui.anonAvatar();
                    }, 300);
                });
            }
            markMessageAsRead(messageId) {
                for (const msg in this.messageList.items) {
                    if (this.messageList.items[msg].messageId === messageId) {
                        this.messageList.items[msg].isRead = true;
                    }
                }
            }
            strip(html) {
                if (!html)
                    return "";
                const textEl = document.createElement("div");
                textEl.innerHTML = html;
                return textEl.textContent.trim();
            }
            getMessagesOfCurrentFolder(page) {
                if (this.selectedFolderId === this.draftFolderId) {
                    this.messageList = {
                        paginationInfo: {
                            totalPages: 1,
                            totalItemsCount: this.drafts.length
                        },
                        items: this.drafts.filter(x => x.lastUpdate >= moment(this.filter.filterDateFrom).startOf('day').toDate() && x.lastUpdate <= moment(this.filter.filterDateTo).endOf('day').toDate()).map(x => ({
                            id: x.id,
                            objectId: x.id,
                            messageId: x.id,
                            messageObjectId: x.id,
                            folderObjectId: this.draftFolderId,
                            senderObjectId: $('#session').data().personId,
                            sender: x.content.subject,
                            subject: this.strip(x.content.text),
                            previewText: '',
                            isRead: true,
                            hasDocuments: false,
                            isSelected: false,
                            createdDate: x.lastUpdate
                        }))
                    };
                    this.folderLoading = false;
                    return;
                }
                if (page === undefined || page === null) {
                    page = 0;
                }
                this.loading = true;
                this.readMode = true;
                this.resetMessageList();
                this.nachrichtenService.getMessageList(this.filter.filterDateFrom, this.filter.filterDateTo, this.selectedFolderId, page, -1).then((data) => {
                    this.messageList = data;
                    if (this.$stateParams.messageId !== undefined) {
                        setTimeout(this.$qui.anonAvatar, 350);
                        this.showMessage(this.$stateParams.messageId);
                        this.markMessageAsRead(this.$stateParams.messageId);
                    }
                    else {
                        if (this.messageList.items.length > 1) {
                            setTimeout(this.$qui.anonAvatar, 350);
                            if (this.isInit === false || this.messageList.items[0].isRead) {
                                // on the first load of the message module, just show the message, do not mark it as read
                                this.showMessage(this.messageList.items[0].messageObjectId);
                                this.markMessageAsRead(this.messageList.items[0].messageObjectId);
                            }
                        }
                        else {
                            this.loading = false;
                        }
                    }
                    this.loading = false;
                    this.folderLoading = false;
                    this.isInit = false;
                });
            }
            viewMode() {
                this.readMode = !this.readMode;
                if (!this.readMode)
                    setTimeout(() => { $("#mail-subject").focus(); }, 350);
            }
            getAvailableRecipients() {
                this.availableRecipients = [];
                this.nachrichtenService.getAvailableRecipients().then((data) => {
                    //for (const re in data) data[re].isSelected = false;
                    data.forEach(x => (x.isSelected = false, x.displayTitle = this.$qui.createPersonDisplay(x.lastName, x.firstName, x.shortCaption, x.personNumber)));
                    this.recs = data;
                    this.availableRecipients = data.map((x) => ({ text: x.displayTitle, value: x.objectId, subText: x.institute }));
                });
            }
            markSelectedMessagesAsRead() {
                this.getSelectedMessages();
                if (this.selectedFolderId === undefined) {
                    this.selectedFolderId = QMC.Common.Constants.MESSAGE_INBOX_FOLDER_ID;
                }
                const request = {
                    id: null,
                    folderId: this.selectedFolderId,
                    messageIds: this.selectedMessageIds,
                    objectId: null
                };
                this.nachrichtenService.markMessageAsRead(request);
                this.$state.go(this.$state.current, { folderId: this.selectedFolderId }, { reload: true });
            }
            markShownMessageAsRead() {
                const request = {
                    id: null,
                    folderId: this.shownMessage.folderId,
                    messageIds: [this.shownMessage.objectId],
                    objectId: null
                };
                this.nachrichtenService.markMessageAsRead(request).then(() => {
                    // For keeping the unread messages count on folders fresh
                    this.updateFolderList();
                });
            }
            deleteSelectedMessages() {
                if (this.selectedFolderId === this.draftFolderId) {
                    this.deleteDrafts(this.selectedMessageIds);
                    this.openDraftFolder();
                }
                else if (this.selectedFolderId === QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID || !this.useTrash) {
                    const completed = [];
                    for (let i = 0; i < this.selectedMessageIds.length; i++) {
                        completed.push(false);
                        this.nachrichtenService.deleteMessage(this.selectedMessageIds[i]).then(() => {
                            completed[i] = true;
                            if (this.allTrueInArray(completed)) {
                                this.$state.go(this.$state.current, { folderId: this.selectedFolderId }, { reload: true });
                                this.$qui.notify(this.$qui.deleteNote);
                            }
                        });
                    }
                }
                else {
                    this.moveSelectedMessagesToFolder(QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID);
                }
            }
            allTrueInArray(list) {
                for (let i = 0; i < list.length; i++)
                    if (!list[i])
                        return false;
                return true;
            }
            deleteMessage(id) {
                if (this.selectedFolderId === QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID || !this.useTrash) {
                    this.nachrichtenService.deleteMessage(id).then(() => {
                        this.$state.go(this.$state.current, { folderId: this.selectedFolderId }, { reload: true });
                    });
                }
                else if (this.selectedFolderId === QMC.Common.Constants.MESSAGE_SENT_FOLDER_ID) {
                    this.nachrichtenService.deleteMessage(id, true).then(() => {
                        this.$state.go(this.$state.current, { folderId: this.selectedFolderId }, { reload: true });
                    });
                }
                else {
                    this.moveMessageToFolder(id, QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID);
                }
            }
            moveSelectedMessagesToFolder(folderId) {
                this.getSelectedMessages();
                const updateItems = [];
                for (let i = 0; i < this.selectedMessageIds.length; i++) {
                    updateItems.push({
                        folderId: this.selectedFolderId,
                        messageId: this.selectedMessageIds[i]
                    });
                }
                const request = {
                    id: null,
                    messages: updateItems,
                    targetFolderId: folderId,
                    objectId: null
                };
                this.nachrichtenService.moveMessageToFolder(request).then(() => {
                    $('#transferMailsModal').modal('hide');
                    setTimeout(() => { this.$state.go(this.$state.current, { folderId: this.selectedFolderId }, { reload: true }); }, 400);
                });
            }
            moveMessageToFolder(messageId, folderId) {
                const messages = [];
                messages.push({
                    folderId: this.selectedFolderId,
                    messageId: messageId
                });
                const request = {
                    id: null,
                    messages: messages,
                    targetFolderId: folderId,
                    objectId: null
                };
                this.nachrichtenService.moveMessageToFolder(request).then(() => {
                    setTimeout(() => { this.$state.go(this.$state.current, { folderId: this.selectedFolderId }, { reload: true }); }, 400);
                });
            }
            sendNewMessage() {
                if (this.selectedRecs.length <= 0)
                    return;
                // Attach the attachments to the attached attachment-object
                const attachments = [];
                for (let i = 0; i < this.selectedFileNames.length; i++) {
                    const attachment = { fileName: this.selectedFileNames[i], attachmentBase64String: this.uploads[i] };
                    attachments.push(attachment);
                }
                this.newForm.attachments = attachments;
                this.newForm.messageText = $('#summernoteNewMessage').find('.note-editable').html();
                this.loading = true;
                this.nachrichtenService.postMessage(this.newForm).then((e) => {
                    $('#loadingScreen').modal('hide');
                    this.loading = false;
                    // Force backdrop to go away
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (e !== (null || undefined)) {
                        if (this.currentDraftId)
                            this.deleteDrafts([this.currentDraftId]);
                        if (this.selectedFolderId === this.draftFolderId)
                            this.openDraftFolder();
                        else
                            this.$state.go(this.$state.current, { folderId: this.selectedFolderId }, { reload: true });
                    }
                }).catch(() => {
                    $('#loadingScreen').modal('hide');
                    this.loading = false;
                });
            }
            sendAnswer() {
                const createData = { messageText: null, recipientIds: null, subject: null, attachments: null };
                // Attach the attachments to the attached attachment-object
                const attachments = [];
                for (let i = 0; i < this.selectedFileNames.length; i++) {
                    const attachment = { fileName: this.selectedFileNames[i], attachmentBase64String: this.uploads[i] };
                    attachments.push(attachment);
                }
                createData.attachments = attachments;
                createData.recipientIds = [];
                if (this.replyToAll === true) {
                    for (let i = 0; i < this.shownMessage.recipients.length; i++) {
                        createData.recipientIds.push(this.shownMessage.recipients[i].recipientObjectId);
                    }
                }
                else {
                    createData.recipientIds.push(this.shownMessage.senderObjectId);
                }
                createData.subject = `${this.lng.translate(21004048, 'AW')}: ${this.shownMessage.subject}`;
                createData.messageText = $('#summernoteAnswerMessage').find('.note-editable').html();
                this.loading = true;
                this.nachrichtenService.postMessage(createData).then(() => {
                    this.deleteDrafts([this.currentDraftId]);
                    $('#loadingScreen').modal('hide');
                    this.loading = false;
                    // Force backdrop to go away
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    this.$state.go(this.$state.current, { folderId: this.selectedFolderId }, { reload: true });
                });
            }
            changeReplyMode(mode) {
                this.uploads = [];
                this.selectedFileNames = [];
                if (mode === 'replyToAll') {
                    this.forward = false;
                    this.reply = false;
                    const draft = this.drafts.filter(x => x.internalMessageId === this.shownMessage.objectId)[0];
                    if (draft) {
                        this.currentDraftId = draft.id;
                        $('#summernoteAnswerMessage').find('.note-editable').html(draft.content.text);
                    }
                }
                if (mode === 'reply') {
                    this.forward = false;
                    this.replyToAll = false;
                    const draft = this.drafts.filter(x => x.internalMessageId === this.shownMessage.objectId)[0];
                    if (draft) {
                        this.currentDraftId = draft.id;
                        $('#summernoteAnswerMessage').find('.note-editable').html(draft.content.text);
                    }
                }
                if (mode === 'forward') {
                    this.reply = false;
                    if (this.forward) {
                        this.forwardRecipients = [];
                        this.selectedFileNames = this.shownMessage.attachments.map(x => {
                            return x.caption && x.caption.length > 0 ? x.caption : x.fileName;
                        });
                        this.uploads = this.shownMessage.attachments.map(x => 'fwrd;' + x.parentObjectId + ';' + x.objectId);
                        const draft = this.drafts.filter(x => x.internalMessageId === this.shownMessage.objectId)[0];
                        if (draft) {
                            this.currentDraftId = draft.id;
                            this.forwardRecipients = draft.content.recipientIds;
                            $('#summernoteForwardMessage').find('.note-editable').html(draft.content.text);
                        }
                    }
                }
            }
            sendForward() {
                const createData = { messageText: null, recipientIds: null, subject: null, attachments: null };
                // Attach the attachments to the attached attachment-object
                const attachments = [];
                for (let i = 0; i < this.selectedFileNames.length; i++) {
                    const attachment = { fileName: this.selectedFileNames[i], attachmentBase64String: this.uploads[i] };
                    attachments.push(attachment);
                }
                createData.attachments = attachments;
                createData.recipientIds = this.forwardRecipients;
                createData.subject = `${this.lng.translate(21004049, 'WG')}: ${this.shownMessage.subject}`;
                createData.messageText = $('#summernoteForwardMessage').find('.note-editable').html();
                this.loading = true;
                this.nachrichtenService.postMessage(createData).then(() => {
                    this.deleteDrafts([this.currentDraftId]);
                    $('#loadingScreen').modal('hide');
                    this.loading = false;
                    // Force backdrop to go away
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    this.$state.go(this.$state.current, { folderId: this.selectedFolderId }, { reload: true });
                });
            }
            getAttachment(message, attachmentId) {
                if (message.attachments !== undefined && message.attachments !== null && message.attachments.length > 0) {
                    this.loadingAttachement = true;
                    $('#previewModal').modal('show');
                    this.nachrichtenService.downloadAttachment(message.attachments[0].parentObjectId, attachmentId).then((data) => {
                        try {
                            // Find filename from mail attachments
                            let filename = 'datei';
                            for (let i = 0; i < message.attachments.length; i++) {
                                if (message.attachments[i].objectId === attachmentId) {
                                    filename = message.attachments[i].fileName;
                                }
                            }
                            // get filename suffix and contenttype
                            const temp = filename.split('.');
                            const ext = temp[temp.length - 1];
                            this.fileInfos = {
                                base64: data,
                                fileType: ext,
                                fileName: filename
                            };
                            this.loadingAttachement = false;
                            this.$qui.scopeApply(this.$scope);
                        }
                        catch (e) {
                            console.log(e);
                            this.loadingAttachement = false;
                        }
                    });
                }
            }
            getAllAttachments(message) {
                if (message.attachments !== undefined && message.attachments !== null && message.attachments.length > 0) {
                    this.nachrichtenService.downloadAttachment(message.attachments[0].parentObjectId).then((data) => {
                        try {
                            const filename = 'anhang.zip';
                            const contentType = 'application/zip';
                            this.$qui.notify(this.$qui.downloadNote);
                            const linkElement = document.createElement('a');
                            const blob = this.base64ToBlob(data, contentType);
                            const url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute('download', filename);
                            const clickEvent = new MouseEvent('click', {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        }
                        catch (e) {
                            console.log(e);
                        }
                    });
                }
            }
            base64ToBlob(base64Data, contentType) {
                contentType = contentType || '';
                const sliceSize = 1024;
                const byteCharacters = atob(base64Data);
                const bytesLength = byteCharacters.length;
                const slicesCount = Math.ceil(bytesLength / sliceSize);
                const byteArrays = new Array(slicesCount);
                for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                    const begin = sliceIndex * sliceSize;
                    const end = Math.min(begin + sliceSize, bytesLength);
                    const bytes = new Array(end - begin);
                    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                        bytes[i] = byteCharacters[offset].charCodeAt(0);
                    }
                    byteArrays[sliceIndex] = new Uint8Array(bytes);
                }
                return new Blob(byteArrays, { type: contentType });
            }
            openFileSelector() {
                const fileSelector = angular.element('#fileselect');
                fileSelector.click();
            }
            removeSelectedFile(index) {
                this.selectedFileNames.splice(index, 1);
                this.uploads.splice(index, 1);
            }
            getPagesCount(count) {
                return new Array(count);
            }
            getFolderListForCreate() {
                return this.flatFolderList.map((obj) => ({ value: obj.folderId, text: obj.caption }));
            }
            getFolderListForUpdate() {
                if (!this.flatFolderList || !this.selectedFolder)
                    return [];
                return this.flatFolderList.filter((obj) => (obj.folderId !== this.selectedFolder.folderId) && !this.isChild(this.selectedFolder.children, obj.folderId))
                    .map((obj) => ({ value: obj.folderId, text: obj.caption }));
            }
            isChild(folders, folderId) {
                for (let i = 0; i < folders.length; i++) {
                    const child = folders[i];
                    if (child.folderId === folderId) {
                        return true;
                    }
                    return this.isChild(child.children, folderId);
                }
            }
            createFolder() {
                this.folderFormCreate.order = this.getFolderOrder(this.folderFormCreate.parentFolderId);
                this.nachrichtenService.postFolder(this.folderFormCreate)
                    .then(() => {
                    this.getFolders();
                });
            }
            getFolderOrder(parentId) {
                let folderOrder = 1;
                for (let i = 0; i < this.folderList.length; i++) {
                    const folder = this.folderList[i];
                    if (folder.folderId === parentId) {
                        if (folder.children.length > 0)
                            folderOrder = folder.children.length;
                        break;
                    }
                }
                return folderOrder;
            }
            updateFolder() {
                this.nachrichtenService.putFolder(this.selectedFolder.folderId, this.folderFormUpdate)
                    .then(() => {
                    this.getFolders();
                });
            }
            deleteFolder() {
                QMC.Common.Utilities.confirm(this.promptOptionsFolderDelete, (data) => {
                    if (data) {
                        this.nachrichtenService.deleteFolder(this.selectedFolder.folderId)
                            .then(() => {
                            this.getFolders();
                        });
                        $('#folderModalUpdate').modal('hide');
                    }
                    else {
                        location.hash = '/mailbox';
                    }
                });
            }
            isStandardFolder() {
                if (this.selectedFolder === (null || undefined))
                    return true;
                return this.selectedFolder.id === QMC.Common.Constants.MESSAGE_INBOX_FOLDER_ID ||
                    this.selectedFolder.id === QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID ||
                    this.selectedFolder.id === QMC.Common.Constants.MESSAGE_SENT_FOLDER_ID ||
                    this.selectedFolder.id === this.draftFolderId;
            }
            ////////////////////// DRAFTS //////////////////////
            newMessageDraft(content) {
                if (!this.currentDraftId)
                    this.setDraft({
                        content: {
                            text: content,
                            recipientIds: this.newForm.recipientIds,
                            subject: this.newForm.subject
                        },
                        lastUpdate: new Date()
                    });
                else {
                    const draft = this.drafts.filter(x => x.id === this.currentDraftId)[0];
                    draft.content = {
                        text: content,
                        recipientIds: this.newForm.recipientIds,
                        subject: this.newForm.subject
                    };
                    this.setDraft(draft);
                }
            }
            forwardMessageDraft(content) {
                this.existingMessageDraft(content, this.forwardRecipients, `${this.lng.translate(21004049, 'WG')}: ${this.shownMessage.subject}`);
            }
            replyMessageDraft(content) {
                const recipients = [this.shownMessage.senderObjectId];
                if (this.replyToAll) {
                    this.shownMessage.recipients.forEach(x => recipients.push(x.recipientObjectId));
                }
                this.existingMessageDraft(content, recipients, `${this.lng.translate(21004048, 'AW')}: ${this.shownMessage.subject}`);
            }
            existingMessageDraft(content, recipients, subject) {
                const present = this.drafts.filter(x => { var _a; return x.internalMessageId === ((_a = this.shownMessage) === null || _a === void 0 ? void 0 : _a.objectId); })[0];
                if (present) {
                    present.content = {
                        subject: subject,
                        recipientIds: recipients,
                        text: content
                    };
                    this.setDraft(present);
                }
                else {
                    this.setDraft({
                        content: {
                            recipientIds: recipients,
                            subject: subject,
                            text: content
                        },
                        lastUpdate: new Date(),
                        internalMessageId: this.shownMessage.objectId
                    });
                }
            }
            openDraftFolder() {
                const folder = {
                    mailboxFolderWvId: this.draftFolderId,
                    caption: 'Entwurf',
                    isFixed: true,
                    order: 1000,
                    unreadCount: this.drafts.length,
                    folderId: this.draftFolderId,
                    children: [],
                    id: this.draftFolderId,
                    objectId: this.draftFolderId
                };
                this.readMode = true;
                this.changeFolder(folder);
                this.ui.toState(2);
            }
            openDraft(id) {
                const draft = this.drafts.filter(x => x.id === id)[0];
                if (!draft)
                    return;
                this.lastDraftSave = undefined;
                this.resetNewForm();
                this.currentDraftId = draft.id;
                this.newForm = {
                    attachments: [],
                    messageText: draft.content.text,
                    recipientIds: draft.content.recipientIds,
                    subject: draft.content.subject
                };
                // Select recipients
                for (const rec of this.recs) {
                    rec.isSelected = draft.content.recipientIds.some(x => x === rec.objectId);
                }
                this.recSelect();
                this.viewMode();
                this.ui.toState(2);
                this.$qui.bindEvents();
                $('#summernoteNewMessage').find('.note-editable').html(draft.content.text);
            }
            getDrafts() {
                this.nachrichtenService.getDrafts().then((data) => {
                    this.drafts = data;
                }).catch(() => {
                    this.drafts = [];
                });
            }
            deleteDrafts(ids) {
                ids.forEach((id) => {
                    if (!id)
                        return;
                    this.drafts = this.drafts.filter(x => x.id !== id);
                    this.nachrichtenService.deleteDraft(id);
                });
                this.lastDraftSave = undefined;
                this.currentDraftId = undefined;
                if (this.selectedFolderId === this.draftFolderId) {
                    this.setFilterView('hide', 140);
                }
            }
            setDraft(data) {
                if (this.isDraftPosting) {
                    setTimeout(() => {
                        this.setDraft(data);
                    }, 500);
                    return;
                }
                data.lastUpdate = new Date();
                if (!this.currentDraftId) {
                    if (this.draftIsEmpty(data))
                        return;
                    this.isDraftPosting = true;
                    this.nachrichtenService.postDraft(data).then((e) => {
                        this.currentDraftId = e;
                        this.isDraftPosting = false;
                        data.id = e;
                        this.drafts.push(data);
                    });
                }
                else {
                    if (this.draftIsEmpty(data)) {
                        this.deleteDrafts([this.currentDraftId]);
                    }
                    else {
                        data.id = this.currentDraftId;
                        this.drafts = this.drafts.filter(x => x.id !== this.currentDraftId);
                        this.drafts.push(data);
                        if (!this.lastDraftSave) {
                            this.lastDraftSave = data;
                            setTimeout(() => {
                                if (!this.currentDraftId || !this.lastDraftSave)
                                    return;
                                this.nachrichtenService.putDraft(this.currentDraftId, this.lastDraftSave);
                                this.lastDraftSave = undefined;
                            }, 5000);
                        }
                        else {
                            this.lastDraftSave = data;
                        }
                    }
                }
            }
            draftIsEmpty(draft) {
                return draft.content.recipientIds.length === 0
                    && draft.content.subject.length === 0
                    && this.strip(draft.content.text).length === 0;
            }
        };
        NachrichtenController = __decorate([
            QMC.Controller('QMC.Nachrichten', 'NachrichtenController'),
            QMC.Inject('$location', 'NachrichtenService', '$qui', '$stateParams', '$state', '$scope', 'QmcLanguageService', 'UserService')
        ], NachrichtenController);
    })(InternalMessage = QMC.InternalMessage || (QMC.InternalMessage = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var InternalMessage;
    (function (InternalMessage) {
        class UserInterface extends QMC.Common.UserInterface {
            constructor() {
                super();
                this.state = 0;
                /**
                 * Folder form
                 * @memberOf UserInterface
                 */
                this.folderForm = {
                    form: [
                        {
                            label: "Name",
                            placeholder: "Name",
                            type: "String",
                            lngTag: "20000072",
                            required: true,
                            model: "name",
                            validate: {
                                message: "Bitte den Ordnernamen angeben.",
                                messageTag: "21004036"
                            },
                            style: {
                                class: "col-xs-6"
                            }
                        },
                        {
                            label: "Parentordner",
                            placeholder: "Parentordner",
                            type: "Select",
                            lngTag: "21004037",
                            required: true,
                            model: "parentFolderId",
                            dataSource: "getFolderListForCreate",
                            validate: {
                                message: "Bitte den �bergeordneten Ordner ausw�hlen",
                                messageTag: "21004038",
                            },
                            style: {
                                class: "col-xs-6"
                            }
                        }
                    ],
                    actions: {
                        post: "createFolder"
                    }
                };
                this.folderFormUpdate = {
                    form: [
                        {
                            label: "Name",
                            placeholder: "Name",
                            type: "String",
                            lngTag: "20000072",
                            required: true,
                            model: "name",
                            validate: {
                                message: "Bitte den Ordnernamen angeben.",
                                messageTag: "21004036"
                            },
                            style: {
                                class: "col-xs-4"
                            }
                        },
                        {
                            label: "Parentordner",
                            placeholder: "Parentordner",
                            type: "Select",
                            lngTag: "21004037",
                            required: true,
                            model: "parentFolderId",
                            dataSource: "getFolderListForUpdate",
                            validate: {
                                message: "Bitte den �bergeordneten Ordner ausw�hlen",
                                messageTag: "21004038",
                            },
                            style: {
                                class: "col-xs-4"
                            }
                        },
                        {
                            label: "Reihenfolge",
                            placeholder: "Reihenfolge",
                            type: "String",
                            lngTag: "21004039",
                            required: true,
                            model: "order",
                            validate: {
                                message: "Bitte die Reihenfolge angeben.",
                                messageTag: "21004040"
                            },
                            style: {
                                class: "col-xs-4"
                            }
                        }
                    ],
                    actions: {
                        put: "updateFolder",
                        delete: "deleteFolder"
                    }
                };
                this.onMobile();
                this.onDesktop();
            }
            /** Read fresh each time so templates stay aligned with body / UA after $qui.init. */
            get mobile() {
                return super.isMobile();
            }
            onDesktop() {
                if (super.isMobile())
                    return;
            }
            onMobile() {
                if (!super.isMobile())
                    return;
                this.initStates();
            }
            initStates() {
                $("[data-state]").each(this.initState);
            }
            // tslint:disable-next-line:no-unused-variable
            toState(state) {
                if (!super.isMobile())
                    return;
                var vm = this;
                vm.state = state;
                console.log("Go To State", state);
                $("[data-state]").each(function (index) {
                    ($(this).data().state === vm.state) ? $(this).show() : $(this).hide();
                    if (vm.state > 1)
                        $("[data-state=\"1\"]").show();
                });
            }
            initState(index) {
                var data = $(this).data();
                $(this).addClass("mobile-fullscreen");
                if (data.state !== 0)
                    $(this).hide();
            }
        }
        InternalMessage.UserInterface = UserInterface;
    })(InternalMessage = QMC.InternalMessage || (QMC.InternalMessage = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Nachrichten/qmc.nachrichten.js.map
